import Bugsnag from '@bugsnag/js';
import { getLocalStorageAuthState } from '@utils/auth';
import { isAxiosError } from '@utils/requests';
import { AxiosError } from 'axios';

import {
  isValidError,
  isEmpty,
  hideSensitiveData,
  defaultSensitiveData,
  isNetworkError,
} from './utils';

export type ErrorSeverityType = 'error' | 'warning' | 'info';

export interface BugsnagOptions {
  severity?: ErrorSeverityType;
  unhandled?: boolean;
  [key: string]: unknown;
  logs?: Record<string, unknown>[];
}
/* The log function that triggers bugsnag.notify */
export const log = (
  error?: Error | AxiosError | unknown,
  options: BugsnagOptions = {}
) => {
  console.log('log', error, options);

  /* If this is not a valid error */
  if (!error || !isValidError(error)) {
    return;
  }

  /* If this is not a Error or AxiosError */
  if (!(error instanceof Error) && !isAxiosError(error)) {
    return;
  }

  if (isAxiosError(error) && isNetworkError(error.code)) {
    return;
  }

  const { severity = 'error', logs = [], ...extraData } = options;
  const user = getLocalStorageAuthState().user;

  Bugsnag.notify(error, async event => {
    if (!isEmpty(extraData)) {
      event.addMetadata(
        'extraData',
        hideSensitiveData(extraData, defaultSensitiveData)
      );
    }

    if (logs.length && Array.isArray(logs)) {
      event.addMetadata('logs', hideSensitiveData(logs, defaultSensitiveData));
    }

    /* Misc */
    if (user) {
      event.setUser(user.id, user.email);
    }

    event.unhandled = Boolean(extraData.unhandled);
    event.severity = severity;
  });
};
